import { useFilters } from '@/platform/hooks/useFilters';
import {
    Container,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
} from '@/platform/ui';
import Navigation from '@/platform/views/Questionnaires/components/Navigation';
import QuestionnaireForm from '@/platform/views/Questionnaires/components/QuestionnaireForm';

export const navItems = [
    {
        value: 2,
        label: 'SROI 18-56',
    },
    {
        value: 3,
        label: 'SROI 56+',
    },
];

const CreateOrUpdateView = () => {
    const { filters, updateFilters } = useFilters(['questionnaire']);

    return (
        <Container>
            <Navigation />

            <Segment>
                <SegmentHeader
                    header='SROI vragenlijst instellingen'
                    subheader='Gebruik deze sectie om sroi vragen te definiëren die in vragenlijsten zullen verschijnen.'
                />
                <SegmentContent>
                    <TabNav label='Categorie'>
                        {navItems.map(navItem => (
                            <TabNavItem
                                key={navItem.value}
                                active={filters.type == navItem.value}
                                onClick={() =>
                                    updateFilters('type', navItem.value)
                                }
                            >
                                {navItem.label}
                            </TabNavItem>
                        ))}
                    </TabNav>
                </SegmentContent>
            </Segment>

            <QuestionnaireForm submitUrl='/services/sroi/questionnaires' />
        </Container>
    );
};

export default CreateOrUpdateView;
